import { computed, ref } from '@/composition/vue/compositionApi'

export const useDragAndDropFiles = (onDropFiles: (files: File[]) => void) => {
  const dragOverCounter = ref(0)
  const isDragOver = computed(() => dragOverCounter.value > 0)

  const onDragEnter = (event: DragEvent) => {
    if (isFileDataTransfer(event.dataTransfer)) {
      dragOverCounter.value += 1
    }
  }

  const onDragLeave = (event: DragEvent) => {
    if (isFileDataTransfer(event.dataTransfer)) {
      dragOverCounter.value -= 1
    }
  }

  const onDragOver = (event: DragEvent) => {
    event.preventDefault()
  }

  const onDrop = (event: DragEvent) => {
    event.preventDefault()
    if (isFileDataTransfer(event.dataTransfer)) {
      dragOverCounter.value = 0
      onDropFiles(Array.from(event.dataTransfer?.files || []))
    }
  }

  return {
    isDragOver,
    dropZoneProps: {
      onDragenter: onDragEnter,
      onDragleave: onDragLeave,
      onDragover: onDragOver,
      onDrop,
    },
  }
}

const isFileDataTransfer = (dataTransfer: DataTransfer | null) => {
  return dataTransfer && dataTransfer.types.includes('Files')
}
